export const UPDATE_TEXT_BLOCKS = 'update-text-blocks';
export const UPDATE_TEXT_OVERLAY_SHOW = 'update-text-overlay-show';

export const updateTextBlocks = textBlocks => {
  return {
    type: UPDATE_TEXT_BLOCKS,
    textBlocks,
  };
};

export const updateTextOverlayShow = show => {
  return {
    type: UPDATE_TEXT_OVERLAY_SHOW,
    show,
  };
};
